import React from 'react';
import { Navigate } from 'react-router-dom';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { useAuth } from '../context-providers/auth-provider';
import ROUTES from './routes';

export default function NoAuthRoute(props: any) {
    const { isAuthenticated, isVerified, initialized } = useAuth();

    if (!initialized) {
        return (<Backdrop open><CircularProgress color="inherit" /></Backdrop>);
    }

    if (!isAuthenticated()) {
        return <>{props.children}</>;
    }

    if (!isVerified()) {
        return <Navigate to={ROUTES.CONFIRM} replace />;
    }

    return <Navigate to={ROUTES.HOME} replace />;
}
